import DOMPurify from 'dompurify';
import MarkdownIt from 'markdown-it';

interface SafeMarkdownOptions {
    html?: boolean;
    linkify?: boolean;
    typographer?: boolean;
}

export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['style'],
});

export const createSafeMarkdown = (options: SafeMarkdownOptions = {}): MarkdownIt => {
    const markdown = new MarkdownIt({ ...options, html: options.html === true });
    const render = markdown.render.bind(markdown);
    markdown.render = (source: string, environment?: unknown) =>
        sanitizeHtml(render(source, environment));
    return markdown;
};
